import { useState } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import Notification from '../../SharedComponents/Notification';
import { toggleStatusPoll } from './ApiPolls';

export default function TogglePollStatus(props) {
  const { pollStatus, id } = props;
  const [activeToggle, setActiveToggle] = useState(pollStatus);
  const queryClient = useQueryClient();

  const { mutate, data } = useMutation(toggleStatusPoll, {
    onSuccess: (data) => {
      queryClient.invalidateQueries(['polls']);
    },
  });

  const handleClick = async (e) => {
    setActiveToggle(!activeToggle);
    const newData = { id: id, isActive: !activeToggle };
    // setNewUserRole(parseInt(e.role));

    try {
      await mutate(newData);
    } catch (error) {
//       console.log('error', error);
    }
  };

  return (
    <>
      <button onClick={handleClick} className="flex items-center cursor-pointer focus:outline-none">
        {/* <!-- toggle --> */}
        <div className="relative">
          {/* <!-- line --> */}
          <div
            className={` w-12 h-6 ${activeToggle ? 'bg-lightgreen' : 'bg-gray-400'}  rounded-full shadow-inner`}
          ></div>
          {/* <!-- dot --> */}
          <div
            className={`transition-all ease-in-out duration-700 absolute w-6 h-6 bg-white rounded-full shadow inset-y-0 ${
              activeToggle ? 'right-0' : 'left-0'
            } `}
          ></div>
        </div>
        {/* <!-- label --> */}
      </button>
      {activeToggle !== pollStatus && <Notification message="Poll Status Changed Successfully" />}
    </>
  );
}
